import "./style.css";
import { cn } from "../../../utils/classnames";
import CountryCodePicker from "./CountryCodePicker";

// Keeps digits only, and hands the parent a change event whose value is the
// cleaned number (the parent's handler reads e.target.name / e.target.value).
const toDigitsOnlyEvent = (event, name) => ({
    ...event,
    target: {
        ...event.target,
        name,
        value: event.target.value.replace(/[^0-9]/g, ""),
    },
});

/**
 * Phone number field: country dial-code picker + number input, drawn as one
 * box. Used on the individual and business registration pages and My Page.
 */
const PhoneNumberForm = ({
    placeholder = "",
    suffixClass = "mb-3",
    mbLabel = "mb-1",
    suffixClassLabel,
    onChange,
    value,
    name,
    label = null,
    disable = false,
    onBlur,
    isInvalid = false,
    invalidMessage = "",
    innerRef,
    id,
    prefixPhoneNumber,
    countryCode,
    onClickCountryList,
}) => {
    return (
        <div className={suffixClass}>
            {label && (
                <label htmlFor={id} className={`${mbLabel ?? ""} ${suffixClassLabel ?? ""}`}>
                    {label}
                </label>
            )}

            <div
                className={cn(
                    "tw:flex tw:items-stretch tw:rounded tw:border tw:bg-white tw:transition-[border-color,box-shadow] tw:duration-200",
                    "tw:focus-within:border-[#DBBE78] tw:focus-within:shadow-[0_0_0_3px_rgba(219,190,120,0.18)]",
                    isInvalid ? "tw:border-[#E5484D]" : "tw:border-[#DEE2E6]",
                    disable && "tw:bg-[#F6F6F6]"
                )}
            >
                <CountryCodePicker
                    countryCode={countryCode}
                    dialCode={prefixPhoneNumber}
                    onSelect={onClickCountryList}
                    disabled={disable}
                />
                <input
                    ref={innerRef}
                    id={id}
                    type="text"
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    disabled={disable}
                    onBlur={onBlur}
                    onChange={(event) => onChange(toDigitsOnlyEvent(event, name))}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="input-field tw:!min-w-0 tw:!flex-1 tw:!rounded-r tw:!bg-transparent tw:!px-3 tw:!py-2"
                />
            </div>

            {isInvalid && invalidMessage !== "" && <p className="m-0 text-danger">{invalidMessage}</p>}
        </div>
    );
};

export default PhoneNumberForm;
